"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const fi_1 = require("react-icons/fi");
const react_router_dom_1 = require("react-router-dom");
const ParametresNavTab_1 = __importDefault(require("./ParametresNavTab"));
require("./ParametresAdmin.css");
const Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
const io5_1 = require("react-icons/io5");
const AddOrUpdateTollPointModal_1 = __importDefault(require("./modals/AddOrUpdateTollPointModal"));
const AddOrUpdateTariffModal_1 = __importDefault(require("./modals/AddOrUpdateTariffModal"));
const AddOrUpdateAdminModal_1 = __importDefault(require("./modals/AddOrUpdateAdminModal"));
const AddOrUpdateCategoryModal_1 = __importDefault(require("./modals/AddOrUpdateCategoryModal"));
const AddOrUpdateSpaceModal_1 = __importDefault(require("./modals/AddOrUpdateSpaceModal"));
const AddOrUpdateDirectionModal_1 = __importDefault(require("./modals/AddOrUpdateDirectionModal"));
const AddOrUpdateFaqModal_1 = __importDefault(require("./modals/AddOrUpdateFaqModal"));
const ParametresAdmin = () => {
    let location = (0, react_router_dom_1.useLocation)();
    const [show, setShow] = (0, react_1.useState)(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const [showTollPointModal, setShowTollPointModal] = (0, react_1.useState)(false);
    const [showTariffModal, setShowTariffModal] = (0, react_1.useState)(false);
    const [showSpaceModal, setShowSpaceModal] = (0, react_1.useState)(false);
    const [showCategoryModal, setShowCategoryModal] = (0, react_1.useState)(false);
    const [showDirectionModal, setShowDirectionModal] = (0, react_1.useState)(false);
    const [showFaqModal, setShowFaqModal] = (0, react_1.useState)(false);
    const handleShowTollPointModal = () => {
        setShowTollPointModal(true);
    };
    const handleShowTariffModal = () => {
        setShowTariffModal(true);
    };
    const handleShowSpaceModal = () => {
        setShowSpaceModal(true);
    };
    const handleShowCategoryModal = () => {
        setShowCategoryModal(true);
    };
    const handleShowDirectionModal = () => {
        setShowDirectionModal(true);
    };
    const handleShowFaqModal = () => {
        setShowFaqModal(true);
    };
    const handleCloseTollPointModal = () => {
        setShowTollPointModal(false);
    };
    const handleCloseTariffModal = () => {
        setShowTariffModal(false);
    };
    const handleCloseSpaceModal = () => {
        setShowSpaceModal(false);
    };
    const handleCloseCategoryModal = () => {
        setShowCategoryModal(false);
    };
    const handleCloseDirectionModal = () => {
        setShowDirectionModal(false);
    };
    const handleCloseFaqModal = () => {
        setShowFaqModal(false);
    };
    return (react_1.default.createElement("div", { className: "dashbord-admin-component" },
        react_1.default.createElement("div", { className: "dash-admin-page-content-container mb-3" },
            react_1.default.createElement("div", { className: "container-fluid" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-lg-12" },
                        react_1.default.createElement("div", { className: "sub-title-page-admin pb-3" }, "Param\u00E8tres"),
                        react_1.default.createElement("div", { className: "row mt-5" },
                            react_1.default.createElement("div", { className: "col-lg-12 sunu-autoroute-admin-titre-page-container mb-3" },
                                react_1.default.createElement("div", { className: "admin-kokutana-titre-page" }, "Param\u00E8tres"),
                                react_1.default.createElement("div", { className: "sunu-autoroute-admin-btn-add-container" },
                                    location.pathname ===
                                        "/admin/parametres/tarifs" && (react_1.default.createElement(Dropdown_1.default, { className: "custom-sunu-autoroute-admin-btn-add" },
                                        react_1.default.createElement(Dropdown_1.default.Toggle, { id: "dropdown-tarifs" },
                                            "Ajouter ",
                                            react_1.default.createElement(io5_1.IoChevronDown, null)),
                                        react_1.default.createElement(Dropdown_1.default.Menu, null,
                                            react_1.default.createElement(Dropdown_1.default.Item, { title: "Ajouter un point de p\u00E9age", onClick: handleShowTollPointModal }, "Ajouter un point de p\u00E9age"),
                                            react_1.default.createElement(Dropdown_1.default.Divider, null),
                                            react_1.default.createElement(Dropdown_1.default.Item, { title: "Ajouter un tarif", onClick: handleShowTariffModal }, "Ajouter un tarif")))),
                                    location.pathname ===
                                        "/admin/parametres/espaces" && (react_1.default.createElement(Dropdown_1.default, { className: "custom-sunu-autoroute-admin-btn-add" },
                                        react_1.default.createElement(Dropdown_1.default.Toggle, { id: "dropdown-espaces" },
                                            "Ajouter ",
                                            react_1.default.createElement(io5_1.IoChevronDown, null)),
                                        react_1.default.createElement(Dropdown_1.default.Menu, null,
                                            react_1.default.createElement(Dropdown_1.default.Item, { title: "Ajouter un espace", onClick: handleShowSpaceModal }, "Ajouter un espace"),
                                            react_1.default.createElement(Dropdown_1.default.Divider, null),
                                            react_1.default.createElement(Dropdown_1.default.Item, { title: "Ajouter une cat\u00E9gorie", onClick: handleShowCategoryModal }, "Ajouter une cat\u00E9gorie")))),
                                    location.pathname ===
                                        "/admin/parametres/administrateurs" && (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement("button", { className: "sunu-autoroute-admin-btn-add", onClick: handleShow },
                                            react_1.default.createElement(fi_1.FiPlusSquare, null),
                                            " Ajouter"),
                                        react_1.default.createElement(AddOrUpdateAdminModal_1.default, { show: show, handleClose: handleClose }))),
                                    location.pathname ===
                                        "/admin/parametres/politiques" && (react_1.default.createElement("button", { className: "sunu-autoroute-admin-btn-add" },
                                        react_1.default.createElement(fi_1.FiEdit3, null),
                                        " Modifier")),
                                    location.pathname ===
                                        "/admin/parametres/directions" && (react_1.default.createElement("button", { className: "sunu-autoroute-admin-btn-add", onClick: handleShowDirectionModal },
                                        react_1.default.createElement(fi_1.FiPlusSquare, null),
                                        " Ajouter une direction")),
                                    location.pathname ===
                                        "/admin/parametres/faqs" && (react_1.default.createElement("button", { className: "sunu-autoroute-admin-btn-add", onClick: handleShowFaqModal },
                                        react_1.default.createElement(fi_1.FiPlusSquare, null),
                                        " Ajouter")),
                                    react_1.default.createElement(AddOrUpdateTollPointModal_1.default, { show: showTollPointModal, handleClose: handleCloseTollPointModal }),
                                    react_1.default.createElement(AddOrUpdateTariffModal_1.default, { show: showTariffModal, handleClose: handleCloseTariffModal }),
                                    react_1.default.createElement(AddOrUpdateSpaceModal_1.default, { show: showSpaceModal, handleClose: handleCloseSpaceModal }),
                                    react_1.default.createElement(AddOrUpdateCategoryModal_1.default, { show: showCategoryModal, handleClose: handleCloseCategoryModal }),
                                    react_1.default.createElement(AddOrUpdateDirectionModal_1.default, { show: showDirectionModal, handleClose: handleCloseDirectionModal }),
                                    react_1.default.createElement(AddOrUpdateFaqModal_1.default, { show: showFaqModal, handleClose: handleCloseFaqModal })))),
                        react_1.default.createElement("div", { className: "pb-4 tabs__wrapper" },
                            react_1.default.createElement(ParametresNavTab_1.default, null)),
                        react_1.default.createElement("div", { className: "outlet__wrapper pricing" },
                            react_1.default.createElement(react_router_dom_1.Outlet, null))))))));
};
exports.default = ParametresAdmin;
